// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-search-docs .inputSearch{
    background-color: #0166a0 !important;
}
.cont-search-docs .inputSearch:focus, .cont-search-docs .inputSearch:hover {
    
    color: aliceblue !important;
  }
.body_info_cis_docs {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
  .cont-cis-table-docs {
    position: relative;
    height: 90%;
    width: 100%;
    /* background: rgba(195,195,195);
    background: #003757; */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-cis_docs {
    position: relative;
    justify-content: center;
    display: block;
    height: 98%;
    width: 94%;
    border-radius: 10px;
    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */
    /* border: 2px solid #003757; */
    border-radius: 10px;
  }

  .cont-search-docs {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 80%;
  }
  
  .content-card-cis-docs {
    position: relative;
    height: 100%;
    width: 100%;
    display: block;
    justify-content: center;
    align-items: center;
    border: 1px solid #003757;
    border-radius: 10px;
  }

  .cont-elemen-docs{
    position: relative;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;

  }
  .elemen-docs{
    position: relative;
    width: 85%;
    height: 70%;
    border-radius: 10px;
    border:2px solid #003757;
    display: flex;

  }

  .con-elemen-docs-info{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
    height: 100%;
    color: #003757;
  }
  .con-elemen-docs-img{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10%;
    height: 100%;
  }
  .img-docs:hover{
    cursor: pointer;
  }
  .msgErrorDocs{
    color: green;
    width: 100%;
  text-align: center;
  }

  .actFiles {
    font-size: 14px;
    font-size: 14px;
    background: aliceblue;
    color: #003757;
    border-radius: 5px;
    height: 5vh;
    width: 20vh;
    overflow: hidden;
    box-shadow: 0 0 0 0 transparent;
    transition: all 0.2s ease-in;
  }


  .custom-file-input {
    position: relative;
    overflow: hidden;
    display: flex;
width: 100%;
height: 100%;
justify-content: center;
align-items: center;
  }
  
  .input-file {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
  }
  
  .btn {
    display: flex;
    /* padding: 8px 20px; */
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #007bff;
    border-radius: 4px;
    cursor: pointer;
    width: 25%;
    height: 60%;
    text-align: center;
    justify-content: center;
    align-items:center ;
  }
  
  #nombre-archivo {
    display: flex;
    margin-top: 10px;
    width: 60%;
    height: 100%;
    align-items: center;
    color: #003757;
    font-size: small;
  }


  .cont-docs-menu{
    position: relative;
    width: 100%;
    height: 90%;
    border: 1px solid #003757;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  }
  .compact-switch-docs-menu{
    position: relative;
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .container-switch-docs-menu {
    margin: auto;
    color: hsl(0, 0%, 30%);
    font-weight: 900;
    /* font-size: 5rem; */
    display: flex;
    height: 100%;
  width: 100%;
  }
  
  .toggle {
    position: relative;
    top:5%;
    width: 25%;
    height: 75%;
    background-color: hsl(0, 0%, 80%);
    border-radius: 1.7rem;
    padding: .25rem 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    transition: background-color 300ms 300ms;
  }
  
  .toggle__circle {
    width: 20px;
    height: 20px;
    background-color: hsl(0, 0%, 95%);
    border-radius: 50%;
    margin-top: calc(50px - (.25rem * 2) - 20px);
    transition: margin 500ms ease-in-out;
  }
  
  .toggle-text {
    display: flex;
    flex-direction: column;
    line-height: .8;
    justify-content: center;
  align-items: center;
  height: 100%;
  }
  
  #check:checked + .toggle > .toggle__circle {
    margin-top: 0;
  }
  
  #check:checked + .toggle {
    background-color: #f44336;
  }
  
  :not(#check:checked) + .toggle {
    background-color: #3682f4;
  }


  .form-docs-cis{
    position: relative;
    display: flex;
    width: 80%;
    height: 100%;
  }

  .cont-inpt-url-doc{
    position: relative;
    display: block;
    width: 80%;
    height: 100%;
    padding: 1%;
  }

  .inp-doc-url{
    background: transparent;
  border: 2px solid #003757;
  /* border-radius: 10%; */
  border-top: unset;
  border-left: unset;
  height: 40%;
  width: 90%;
  color: gray;
  font-size: medium;
  }
  .inp-doc-url:focus{
    border-color: transparent !important;
   
}
.inp-doc-url:focus-visible{
  border-color: transparent !important;
 
}
  .lbl-doc-url{
    position: relative;
    display: flex;
    height: 30%;
    color: #003757;
  }

  .cont-img-field-acciones a{
    position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  }`, "",{"version":3,"sources":["webpack://./src/components/cis-components/styles/ModalCisDocs.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;AACA;;IAEI,2BAA2B;EAC7B;AACF;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX;0BACsB;IACtB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,2FAA2F;IAC3F,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;EAErB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,wBAAwB;IACxB,aAAa;;EAEf;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb,kBAAkB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,+BAA+B;IAC/B,4BAA4B;EAC9B;;;EAGA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB,WAAW;AACX,YAAY;AACZ,uBAAuB;AACvB,mBAAmB;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;;;EAGA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yBAAyB;EAC3B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;;EAGA;IACE,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,aAAa;IACb,YAAY;EACd,WAAW;EACX;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,WAAW;IACX,iCAAiC;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,wCAAwC;EAC1C;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,4CAA4C;IAC5C,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,uBAAuB;EACzB,mBAAmB;EACnB,YAAY;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;;EAGA;IACE,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB;EACA;IACE,oCAAoC;;AAExC;AACA;EACE,oCAAoC;;AAEtC;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB","sourcesContent":[".cont-search-docs .inputSearch{\r\n    background-color: #0166a0 !important;\r\n}\r\n.cont-search-docs .inputSearch:focus, .cont-search-docs .inputSearch:hover {\r\n    \r\n    color: aliceblue !important;\r\n  }\r\n.body_info_cis_docs {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .cont-cis-table-docs {\r\n    position: relative;\r\n    height: 90%;\r\n    width: 100%;\r\n    /* background: rgba(195,195,195);\r\n    background: #003757; */\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  .content-cis_docs {\r\n    position: relative;\r\n    justify-content: center;\r\n    display: block;\r\n    height: 98%;\r\n    width: 94%;\r\n    border-radius: 10px;\r\n    /* box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15); */\r\n    /* border: 2px solid #003757; */\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .cont-search-docs {\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 80%;\r\n  }\r\n  \r\n  .content-card-cis-docs {\r\n    position: relative;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border: 1px solid #003757;\r\n    border-radius: 10px;\r\n  }\r\n\r\n  .cont-elemen-docs{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 60px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n  }\r\n  .elemen-docs{\r\n    position: relative;\r\n    width: 85%;\r\n    height: 70%;\r\n    border-radius: 10px;\r\n    border:2px solid #003757;\r\n    display: flex;\r\n\r\n  }\r\n\r\n  .con-elemen-docs-info{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 80%;\r\n    height: 100%;\r\n    color: #003757;\r\n  }\r\n  .con-elemen-docs-img{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 10%;\r\n    height: 100%;\r\n  }\r\n  .img-docs:hover{\r\n    cursor: pointer;\r\n  }\r\n  .msgErrorDocs{\r\n    color: green;\r\n    width: 100%;\r\n  text-align: center;\r\n  }\r\n\r\n  .actFiles {\r\n    font-size: 14px;\r\n    font-size: 14px;\r\n    background: aliceblue;\r\n    color: #003757;\r\n    border-radius: 5px;\r\n    height: 5vh;\r\n    width: 20vh;\r\n    overflow: hidden;\r\n    box-shadow: 0 0 0 0 transparent;\r\n    transition: all 0.2s ease-in;\r\n  }\r\n\r\n\r\n  .custom-file-input {\r\n    position: relative;\r\n    overflow: hidden;\r\n    display: flex;\r\nwidth: 100%;\r\nheight: 100%;\r\njustify-content: center;\r\nalign-items: center;\r\n  }\r\n  \r\n  .input-file {\r\n    font-size: 100px;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    opacity: 0;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .btn {\r\n    display: flex;\r\n    /* padding: 8px 20px; */\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n    color: #fff;\r\n    background-color: #007bff;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    width: 25%;\r\n    height: 60%;\r\n    text-align: center;\r\n    justify-content: center;\r\n    align-items:center ;\r\n  }\r\n  \r\n  #nombre-archivo {\r\n    display: flex;\r\n    margin-top: 10px;\r\n    width: 60%;\r\n    height: 100%;\r\n    align-items: center;\r\n    color: #003757;\r\n    font-size: small;\r\n  }\r\n\r\n\r\n  .cont-docs-menu{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 90%;\r\n    border: 1px solid #003757;\r\n  border-radius: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  }\r\n  .compact-switch-docs-menu{\r\n    position: relative;\r\n    width: 20%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n\r\n  .container-switch-docs-menu {\r\n    margin: auto;\r\n    color: hsl(0, 0%, 30%);\r\n    font-weight: 900;\r\n    /* font-size: 5rem; */\r\n    display: flex;\r\n    height: 100%;\r\n  width: 100%;\r\n  }\r\n  \r\n  .toggle {\r\n    position: relative;\r\n    top:5%;\r\n    width: 25%;\r\n    height: 75%;\r\n    background-color: hsl(0, 0%, 80%);\r\n    border-radius: 1.7rem;\r\n    padding: .25rem 0;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: center;\r\n    transition: background-color 300ms 300ms;\r\n  }\r\n  \r\n  .toggle__circle {\r\n    width: 20px;\r\n    height: 20px;\r\n    background-color: hsl(0, 0%, 95%);\r\n    border-radius: 50%;\r\n    margin-top: calc(50px - (.25rem * 2) - 20px);\r\n    transition: margin 500ms ease-in-out;\r\n  }\r\n  \r\n  .toggle-text {\r\n    display: flex;\r\n    flex-direction: column;\r\n    line-height: .8;\r\n    justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  }\r\n  \r\n  #check:checked + .toggle > .toggle__circle {\r\n    margin-top: 0;\r\n  }\r\n  \r\n  #check:checked + .toggle {\r\n    background-color: #f44336;\r\n  }\r\n  \r\n  :not(#check:checked) + .toggle {\r\n    background-color: #3682f4;\r\n  }\r\n\r\n\r\n  .form-docs-cis{\r\n    position: relative;\r\n    display: flex;\r\n    width: 80%;\r\n    height: 100%;\r\n  }\r\n\r\n  .cont-inpt-url-doc{\r\n    position: relative;\r\n    display: block;\r\n    width: 80%;\r\n    height: 100%;\r\n    padding: 1%;\r\n  }\r\n\r\n  .inp-doc-url{\r\n    background: transparent;\r\n  border: 2px solid #003757;\r\n  /* border-radius: 10%; */\r\n  border-top: unset;\r\n  border-left: unset;\r\n  height: 40%;\r\n  width: 90%;\r\n  color: gray;\r\n  font-size: medium;\r\n  }\r\n  .inp-doc-url:focus{\r\n    border-color: transparent !important;\r\n   \r\n}\r\n.inp-doc-url:focus-visible{\r\n  border-color: transparent !important;\r\n \r\n}\r\n  .lbl-doc-url{\r\n    position: relative;\r\n    display: flex;\r\n    height: 30%;\r\n    color: #003757;\r\n  }\r\n\r\n  .cont-img-field-acciones a{\r\n    position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
